export const LISTING = 'EVENT_BONUS_SETTING_LIST';
export const STORE = "EVENT_BONUS_SETTING_STORE";
export const DETAILS = "EVENT_BONUS_SETTING_DETAILS";
export const UPDATE = "EVENT_BONUS_SETTING_UPDATE";
export const UPDATE_STATUS = "EVENT_BONUS_SETTING_UPDATE_STATUS";